import { AxiosPromise } from 'axios';

import { ITwitterTokenVerificationParams } from './interfaces';
import { vaultApi } from '../api';

export const verifyTwitterToken = <T>(params: ITwitterTokenVerificationParams): AxiosPromise<any> => vaultApi.getInstance().post('/twitter/verifyToken', params);
